// Libraries
import React, {FunctionComponent, ReactElement} from 'react';
import {Form} from 'antd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Constants and Functions
import {currencyFormat, currencyToNumber} from '../../utils/generalUtils';
const { Item } = Form;


type FormItemComponentType = {
  label?: string;
  name?: string[] | string;
  valuePropName?: string;
  required: boolean;
  withValueValidator?: boolean;
  className?: string;
  child: ReactElement
};
const FormItemComponent: FunctionComponent<FormItemComponentType> = (
  {
    label, name, valuePropName, required, withValueValidator, className, child
  }) => {
  const { t } = useTranslation();

  return (
    withValueValidator
    ?
      <Item label={label} name={name} valuePropName={valuePropName}
            className={'mb-3 [&>div>div]:pb-1 [&>div>div>label]:text-sm [&>div>div>label]:font-medium ' +
              '[&>div>div>label]:text-grey-dkt-400 ' + className
            }
            rules={[{ required: required, message: t('requiredField') }]}
            getValueFromEvent={(e) => {
              const value = currencyToNumber(e.target.value);

              return isNaN(value) ? 0 : currencyFormat(value.toFixed(2).toString());
            }}>
        {child}
      </Item>
      :
      <Item label={label} name={name} valuePropName={valuePropName}
            className={'mb-3 [&>div>div]:pb-1 [&>div>div>label]:text-sm [&>div>div>label]:font-medium ' +
              '[&>div>div>label]:text-grey-dkt-400 ' + className
            }
            rules={[{ required: required, message: t('requiredField') }]}>
        {child}
      </Item>
  );
}

FormItemComponent.propTypes = {
  label: PropTypes.string,
  name: PropTypes.any,
  valuePropName: PropTypes.string,
  required: PropTypes.bool.isRequired,
  withValueValidator: PropTypes.bool,
  className: PropTypes.string,
  child: PropTypes.element.isRequired,
};
FormItemComponent.defaultProps = {
  label: undefined,
  name: undefined,
  valuePropName: 'value',
  required: true,
  withValueValidator: false,
  className: '',
  child: <></>,
};

export default FormItemComponent;